import * as React from "react";
import 'intersection-observer';
import { Action, IOWidget, mk_widget } from "widgets-for-react";
import { CMSState } from "../../../../cms/blocks/types.gen";
import { link, linkWrapper } from "../../../../cms/blocks/utils.gen";
import { PublicSite_CustomPageData } from "../../../application.mod";
import { ButtonData } from "../../../../wordpress/types_and_parser/extra_types.mod";
import { WordPress } from "../../../../wordpress/wordpress_api";
import { getImageAttribute } from "../../../utils/extra_images.mod";

export type StepsBlockProps = {
  blockName: 'vidda/steps'
  index: number
  image: WordPress.MediaResponse
  title?: string
  blocks: Array<{
    attrs: {
      title: string,
      text: string
    }
  }>
  primary_button?: ButtonData 
  secondary_button?: ButtonData
}

export type StepsBlockStyle = Partial<{
  block_classname: string
  inview_classname: string
  inner_classname: string
  header_classname: string
  title_classname: string
  content_classname: string
  text_classname: string
  footer_classname: string
  clickable_wrapper_classname: string
  clickable_primary_classname: string
  clickable_secondary_classname: string
}>

export function StepsBlock<CustomBlockData, extra_images>(
  props: StepsBlockProps,
  options?: { style?: StepsBlockStyle; key?: string }
): IOWidget<CMSState<CustomBlockData, extra_images, PublicSite_CustomPageData>, Action<CMSState<CustomBlockData, extra_images, PublicSite_CustomPageData>>> {
  return (s: CMSState<CustomBlockData, extra_images, PublicSite_CustomPageData>) =>
    mk_widget({
      run: onDone => (
        <section className="block block--steps container--xl">
          <div className="block__inner grid--spacing">
            <div className="block__steps">
              <header className="block__header">
                <h2 className="block__title typo--3xl">{props.title}</h2>
              </header>
              <div className="block__content">
                <ul className="block__list list">
                  {props.blocks.map(block => (
                    <li className="list__item">
                      <h3 className="list__title typo--l">{block.attrs.title}</h3>
                      <div className="list__text" dangerouslySetInnerHTML={{__html: block.attrs.text}} />
                    </li>
                  ))}
                </ul>

              {(props.primary_button || props.secondary_button) && (
                <footer className="block__footer">
                  {props.primary_button &&
                    link(linkWrapper({title:props.primary_button.text,url:props.primary_button.url}),
                      {classname: "button button--primary"},
                      props.primary_button.text
                    )}
                  {props.secondary_button &&
                    link(linkWrapper({title:props.secondary_button.text,url:props.secondary_button.url}),
                      {classname: "button button--secondary"},
                      props.secondary_button.text
                    )}
                </footer>
              )}
              </div>
            </div>

            {props.image && props.image.media_details && (
              <div className="block__visual fit-object">
                <img
                  src={getImageAttribute(props.image, 'step_image', 'source_url')}
                  width={getImageAttribute(props.image, 'step_image', 'width')}
                  height={getImageAttribute(props.image, 'step_image', 'height')}
                  alt={props.image.alt_text ? props.image.alt_text : ''}
                />

                <svg height="65" viewBox="0 0 100 65" width="100"  className="block__mask block__mask--mobile" 
                  xmlns="http://www.w3.org/2000/svg">
                  <path d="m508 480 .036705 19.002446.257295.343554.943969 1.048069c4.358655 4.822845 9.118545 9.889805 13.992145 14.784257 9.977357 9.98591 20.246097 19.211746 29.555361 24.643056 9.731273 5.41741 19.196063 7.352656 28.592641-.2298.069313-.056209.141979-.113312.21587-.172538.141078-.116662.283382-.235447.426911-.356354.261719-.222482.522537-.448315.781877-.686322 3.724907-3.269246 7.280763-7.935152 11.417364-15.070488 3.449686-5.97503 7.327381-13.799882 11.779907-24.075161l-.000045-19.230719h1v21h-.017l.000508 43.994328h-99.950056v-45.96934l.003548-.000988-.037-19.024z" transform="translate(-507 -480)"/>
                </svg>
                <svg  className="block__mask block__mask--desktop" height="2000" viewBox="0 0 920 2000" width="920" xmlns="http://www.w3.org/2000/svg">
                  <g fill="none" fill-rule="evenodd">
                    <path d="m920 0v2010h-920v-19.54686l3.37618027-3.04433c103.61984073-93.45675 213.78888073-196.94872 319.90605473-303.12439 199.851403-200.64508 384.491188-407.14989 493.189843-594.3596 108.420448-195.696328 147.1512-386.033673-4.599078-574.999259-1.124917-1.393898-2.267738-2.855208-3.453046-4.341162-2.334799-2.837087-4.712086-5.698817-7.13185-8.585194-4.452602-5.263177-8.972266-10.508235-13.735581-15.723572-65.428526-74.90805-158.808895-146.416473-301.6108-229.603705-120.377113-69.835584-278.270356-148.393565-485.941723-238.6859189v-17.9860091z" fill="#FFF" fill-rule="nonzero" transform="translate(0 -5)"/>
                    <path d="m0 0h920v2000h-920z"/>
                  </g>
                </svg>
              </div>
            )}
          </div>
        </section>
      )
    });
}
